("use strict");

import React from "react";
import * as ReactDOMClient from "react-dom/client";

import * as sharedComponents from "@shared/components";
import * as cve from "@modules/cve/components";

const components = { cve, shared: sharedComponents };

export const renderComponent = ({ module, component, containerId, props, position = "replace", componentId }) => {
	/**=
	 
		* @param {string} module - The module category the component belongs to.
		* @param {string} component - The name of the react component to be rendered.
		* @param {string} containerId -  The id of the parent element in the DOM that will contain the react component.
		* @param {string} [props] - Data passed to the component.
		* @param {enum} [position=replace] - Where to position the element inside it's container (options: append, prepend, after, before, replace).
		* @param {string} [componentId] - The id given to the component that is rendered to the DOM

	*/

	// get the positioning of the component
	position = ["append", "prepend", "after", "before", "replace"].find((p) => p === position);
	if (!position || position === "replace") position = "html";

	// get the componentId if not provided
	if (typeof componentId !== "string" || !componentId) componentId = component; // use the component name if an componentId is not provided

	// get the container
	let container = $(`#${containerId}`);

	const componentToRender = components[module] ? components[module][component] : null;

	// handle errors
	if (!componentToRender) return console.error(`A component by the name "${component}" doesn't exist in module "${module}".`);
	if ($(`#${componentId}`).length) return console.error(`An element with the id of '${componentId}' already exists in the DOM. Provide a unique componentId`);
	if (!container.length) return console.error(`There is no element in the DOM with an id of '${containerId}'. Provide a containerId for an element that exists in the DOM.`);

	// render component to the DOM
	container[position](`<div id=${componentId}></div>`).ready(() => {
		const element = $(`#${componentId}`);

		const root = ReactDOMClient.createRoot(element[0]);

		root.render(React.createElement(components.shared.RootComponent, null, React.createElement(componentToRender, props)));
	});
};
